import moment from "moment";
export default {
  // encryption(data) {
  //   let obj = this.compileStr(data);
  //   let obj1 = "";
  //   obj1 = window.btoa(obj);
  //   return obj1;
  // },

  /**
   * 加密
   * @param code
   * @returns {string}
   */
  compileStr(code) {
    let c = String.fromCharCode(code.charCodeAt(0) + code.length);
    for(let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
    }
    return escape(c);
  },

  // deciphering(data) {
  //   let objStr = "";
  //   let objStr1 = "";
  //   objStr = window.atob(data);
  //   objStr1 = this.unCompileStr(objStr);
  //   return objStr1;
  // },

  /**
   * 解密
   * @param code
   * @returns {string}
   */
  unCompileStr(code) {
    code = unescape(code);
    let c = String.fromCharCode(code.charCodeAt(0) - code.length);
    for(let i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
  },

  /**
   * 将毫秒转化成年-月-日 时-分-秒
   * @param timestamp
   * @returns {string}
   */
  dateFormat(timestamp) {
    if (timestamp && timestamp != "") {
      let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      return dateStr;
    }
    return "-";
  }
}



// WEBPACK FOOTER //
// ./src/tool/commonFun.js